export default __webpack_public_path__ + "static/media/mouse.32508bb3.png";